export class UpdateOrderPartsMessage { 
  orderPartIds: number[]
  
  constructor(orderPartIds: number[]) {
    this.orderPartIds = orderPartIds
  }
}